import React from 'react';

const OtherBanner = () =>  (
  <div className="flex w-36 max-w-[155px] desktop:w-1/2 py-2 px-4 bg-green-fsbo text-white text-md font-sourcesans">
    <p>For Sale By Owner</p>
  </div>
)

export default OtherBanner;
